/**
 * Order page functionality: brand expand, quantity widget, delete order/product, expected dates.
 *
 * Status dropdown toggle обрабатывается в script_adm.js (.adm_r_filter).
 */

import { apiRequest, APIError } from '../../api.js';

function slideToggle(element, open, duration = 300) {
    if (open) {
        element.style.display = '';
        const height = element.scrollHeight;
        element.style.overflow = 'hidden';
        element.style.height = '0px';
        element.style.transition = `height ${duration}ms ease`;
        requestAnimationFrame(() => { element.style.height = height + 'px'; });
        setTimeout(() => {
            element.style.height = '';
            element.style.overflow = '';
            element.style.transition = '';
        }, duration);
    } else {
        element.style.overflow = 'hidden';
        element.style.height = element.scrollHeight + 'px';
        element.style.transition = `height ${duration}ms ease`;
        requestAnimationFrame(() => { element.style.height = '0px'; });
        setTimeout(() => {
            element.style.display = 'none';
            element.style.height = '';
            element.style.overflow = '';
            element.style.transition = '';
        }, duration);
    }
}

async function deleteOrder(orderId) {
    try {
        const response = await apiRequest(`/manager/order/${orderId}`, { method: 'DELETE' });
        if (response && response.success) {
            window.showToast('success', response.message || 'Order request has been successfully deleted.');
            setTimeout(() => {
                window.location.href = response.redirect || '/manager/orders';
            }, 1000);
        } else {
            window.showToast('error', response?.message || 'Failed to delete order request');
        }
    } catch (e) {
        const msg = e instanceof APIError ? e.message : 'Error deleting order';
        window.showToast('error', msg);
    }
}

async function deleteOrderProduct(orderId, productId) {
    try {
        const response = await apiRequest(`/manager/order/${orderId}/product/${productId}`, { method: 'DELETE' });
        if (response && response.success) {
            window.showToast('success', response.message || 'The item has been successfully deleted.');
            setTimeout(() => {
                if (response.should_delete_order && response.redirect) {
                    window.location.href = response.redirect;
                } else {
                    window.location.reload();
                }
            }, 1000);
        } else {
            window.showToast('error', response?.message || 'Failed to delete item');
        }
    } catch (e) {
        const msg = e instanceof APIError ? e.message : 'Error deleting item';
        window.showToast('error', msg);
    }
}

function updateApproveAllButton() {
    const checkedBrands = document.querySelectorAll('.brand-select-checkbox:checked');
    const approveBtn = document.getElementById('approve-all-btn');
    if (!approveBtn) return;

    if (checkedBrands.length > 0) {
        approveBtn.disabled = false;
        approveBtn.classList.remove('disabled');
    } else {
        approveBtn.disabled = true;
        approveBtn.classList.add('disabled');
    }
}

// Exposed для external callers (approve-all кнопка)
window.getSelectedBrands = function () {
    const selected = [];
    document.querySelectorAll('.brand-select-checkbox:checked').forEach(cb => {
        selected.push(cb.dataset.brandName);
    });
    return selected;
};

// Auto-calculate Expected date from products (ТЗ: "принимает самую позднюю (крайнюю) дату")
function updateExpectedDates() {
    let maxOrderDate = null;

    document.querySelectorAll('.adm_req_brand_item').forEach(brandItem => {
        const brandSlug = brandItem.dataset.brandSlug;
        let maxBrandDate = null;

        brandItem.querySelectorAll('.product-expected-date').forEach(input => {
            if (input.value) {
                const date = new Date(input.value);
                if (!maxBrandDate || date > maxBrandDate) maxBrandDate = date;
                if (!maxOrderDate || date > maxOrderDate) maxOrderDate = date;
            }
        });

        const brandDateEl = document.getElementById('brand_expected_date_' + brandSlug);
        if (brandDateEl && maxBrandDate) {
            const dd = String(maxBrandDate.getDate()).padStart(2, '0');
            const mm = String(maxBrandDate.getMonth() + 1).padStart(2, '0');
            const yy = maxBrandDate.getFullYear();
            // Единый формат отображения дат сайта — d.m.Y (см. config('app.date_format')).
            brandDateEl.textContent = `${dd}.${mm}.${yy}`;
        }
    });

    if (maxOrderDate) {
        const yy = maxOrderDate.getFullYear();
        const mm = String(maxOrderDate.getMonth() + 1).padStart(2, '0');
        const dd = String(maxOrderDate.getDate()).padStart(2, '0');
        const formatted = `${yy}-${mm}-${dd}`;
        const orderDateInput = document.getElementById('order_expected_date');
        if (orderDateInput) orderDateInput.value = formatted;
    }
}

function initOrderPage() {
    // Brand item toggle (открыть/закрыть товары под брендом)
    document.querySelectorAll('.adm_req_brand_item_cap').forEach(cap => {
        cap.addEventListener('click', () => {
            const brandItem = cap.closest('.adm_req_brand_item');
            const brandItems = brandItem?.querySelector('.adm_req_brand_items');
            if (!brandItem || !brandItems) return;

            const isOpening = !brandItem.classList.contains('opened');
            brandItem.classList.toggle('opened', isOpening);
            slideToggle(brandItems, isOpening, 300);
        });
    });

    // Delete order button (selector на странице)
    document.querySelectorAll('.btn_trash').forEach(btn => {
        btn.addEventListener('click', async () => {
            const orderId = btn.dataset.orderId;
            const confirmed = await window.showAdmConfirmation(
                'Are you sure you want to delete this order request?',
                { confirmText: 'Delete', cancelText: 'Cancel' }
            );
            if (confirmed) deleteOrder(orderId);
        });
    });

    // Делегированные обработчики для динамических элементов
    document.addEventListener('click', async e => {
        // Quantity widget —
        const minusBtn = e.target.closest('.adm_vidget_minus');
        if (minusBtn) {
            const widget = minusBtn.closest('.adm_vidget_count');
            const valueEl = widget?.querySelector('.adm_vidget_value');
            if (valueEl) {
                const value = parseInt(valueEl.textContent, 10);
                if (value > 1) {
                    valueEl.textContent = value - 1;
                    if (window.orderCalculator) window.orderCalculator.calculateAll();
                }
            }
            return;
        }

        const plusBtn = e.target.closest('.adm_vidget_plus');
        if (plusBtn) {
            const widget = plusBtn.closest('.adm_vidget_count');
            const valueEl = widget?.querySelector('.adm_vidget_value');
            if (valueEl) {
                const value = parseInt(valueEl.textContent, 10);
                valueEl.textContent = value + 1;
                if (window.orderCalculator) window.orderCalculator.calculateAll();
            }
            return;
        }

        // Delete product button
        const deleteBtn = e.target.closest('.delete-order-product-btn');
        if (deleteBtn) {
            e.preventDefault();
            const productId = deleteBtn.dataset.productId;
            const orderId = deleteBtn.dataset.orderId;

            const confirmed = await window.showAdmConfirmation(
                'Are you sure you want to delete this item?',
                { confirmText: 'Delete', cancelText: 'Cancel' }
            );
            if (confirmed) deleteOrderProduct(orderId, productId);
        }
    });

    // Brand checkbox → update approve-all button
    document.addEventListener('change', e => {
        if (e.target.matches('.brand-select-checkbox')) {
            updateApproveAllButton();
        } else if (e.target.matches('.product-expected-date')) {
            updateExpectedDates();
        }
    });

    // Initial state
    updateApproveAllButton();
    updateExpectedDates();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOrderPage);
} else {
    initOrderPage();
}
